import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../../api';

const Topbar = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);
  const [notificationOpen, setNotificationOpen] = useState(false);
  const [profileOpen, setProfileOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [userData, setUserData] = useState(null);

  const leftSidebarRef = useRef(null);
  const darkTransparentRef = useRef(null);
  const navigate = useNavigate();

  // Fetch user data on component mount
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const token = sessionStorage.getItem('auth_token');
        const userId = sessionStorage.getItem('user_id');
        const Module = sessionStorage.getItem('Module');

        if (userId || token || Module) {
          const response = await api.get('/users-management', {
            headers: {
              'Accept': 'application/vnd.api+json',
              'Content-Type': 'application/vnd.api+json',
              'Authorization': `Bearer ${token}`
            }
          });

          const currentUser = response.data.data.find(user => user.id.toString() === userId);
          if (currentUser) {
            setUserData(currentUser);
          }
        }
      } catch (error) {
        console.error('Error fetching user data:', error);
      }
    };

    fetchUserData();
  }, []);


  // Toggle functions
  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
    document.body.classList.toggle('mini-sidebar');
  };

  const toggleMobileSidebar = () => {
    setMobileSidebarOpen(!mobileSidebarOpen);
    if (leftSidebarRef.current) {
      leftSidebarRef.current.classList.toggle('show-sidebar');
    }
    if (darkTransparentRef.current) {
      darkTransparentRef.current.classList.toggle('show');
    }
  };

  const closeMobileSidebar = () => {
    setMobileSidebarOpen(false);
    if (leftSidebarRef.current) {
      leftSidebarRef.current.classList.remove('show-sidebar');
    }
    if (darkTransparentRef.current) {
      darkTransparentRef.current.classList.remove('show');
    }
  };

  const toggleNotification = (e) => {
    e.preventDefault();
    setNotificationOpen(!notificationOpen);
    setProfileOpen(false);
  };

  const toggleProfile = (e) => {
    e.preventDefault();
    setProfileOpen(!profileOpen);
    setNotificationOpen(false);
  };

  const toggleSearch = (e) => {
    e.preventDefault();
    setSearchOpen(!searchOpen);
  };

  // Logout function
  const handleLogout = () => {
    sessionStorage.removeItem('auth_token');
    sessionStorage.removeItem('user_id');
    sessionStorage.removeItem('Module');
    sessionStorage.removeItem('Role_Name');
    navigate('/');
  };

  // Close dropdowns if clicked outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest('.dropdown') && !e.target.classList.contains('dropdown-toggle')) {
        setNotificationOpen(false);
        setProfileOpen(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  return (
    <header className="topbar">
      <div className="with-vertical">
        <nav className="navbar navbar-expand-lg p-0">
          {/* Left Side: Toggle buttons */}
          <ul className="navbar-nav">
            <li className="nav-item">
              <a
                className="nav-link sidebartoggler nav-icon-hover ms-n3"
                id="headerCollapse"
                onClick={toggleMobileSidebar}
              >
                <i className="ti ti-menu-2"></i>
              </a>
            </li>
            <li className="nav-item d-none d-lg-block">
              <a className="nav-link nav-icon-hover"  onClick={toggleSearch}>
                <i className="ti ti-search"></i>
              </a>
            </li>
          </ul>

          {/* Logo */}
          <div className="d-block d-lg-none">
            <img src="../assets/images/logos/ros-logo.png" width="230" alt="Logo" />
          </div>

          <a className="navbar-toggler nav-icon-hover p-0 border-0 collapsed" href="javascript:void(0)" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
            <span className="p-2">
              <i className="ti ti-dots fs-7"></i>
            </span>
          </a>

          <div className="collapse navbar-collapse justify-content-end" id="navbarNav">
            <div className="d-flex align-items-center justify-content-between">
              <ul className="navbar-nav flex-row ms-auto align-items-center justify-content-center">
                <li className={`nav-item dropdown ${notificationOpen ? 'show' : ''}`}>
                  <a 
                    className="nav-link nav-icon-hover" 
                     
                    onClick={toggleNotification}
                  >
                    <i className="ti ti-bell-ringing"></i>
                    <div className="notification bg-primary rounded-circle"></div>
                  </a>
                  <div 
                    className={`dropdown-menu content-dd dropdown-menu-end dropdown-menu-animate-up ${notificationOpen ? 'show' : ''}`} 
                    data-bs-popper
                  >
                    <div className="d-flex align-items-center justify-content-between py-3 px-7">
                      <h5 className="mb-0 fs-5 fw-semibold">Notifications</h5>
                      <span className="badge text-bg-primary rounded-4 px-3 py-1 lh-sm">5 new</span>
                    </div>
                    <div className="message-body" data-simplebar>
                      <a  className="py-6 px-7 d-flex align-items-center dropdown-item">
                        <span className="me-3">
                          <img src="../assets/images/profile/user-2.jpg" alt="user" className="rounded-circle" width="48" height="48" />
                        </span>
                        <div className="w-75 d-inline-block v-middle">
                          <h6 className="mb-1 fw-semibold lh-base">New message</h6>
                          <span className="fs-2 d-block text-body-secondary">Salma sent you new message</span>
                        </div>
                      </a>
                      <a  className="py-6 px-7 d-flex align-items-center dropdown-item">
                        <span className="me-3">
                          <img 
                            src="../assets/images/profile/user-1.jpg" 
                            alt="user" 
                            className="rounded-circle" 
                            width="48" 
                            height="48" 
                          />
                        </span>
                        <div className="w-75 d-inline-block v-middle">
                          <h6 className="mb-1 fw-semibold lh-base">Roman Joined the Team!</h6>
                          <span className="fs-2 d-block text-body-secondary">Congratulate him</span>
                        </div>
                      </a>
                    </div>
                    <div className="py-6 px-7 mb-1">
                      <button className="btn btn-outline-primary w-100">
                        See All Notifications
                      </button>
                    </div>
                  </div>
                </li>

                {/* Profile & Logout */}
                <li className={`nav-item dropdown ${profileOpen ? 'show' : ''}`}>
                  <a className="nav-link pe-0"  onClick={toggleProfile}>
                    <div className="d-flex align-items-center">
                      <div className="user-profile-img">
                        <img
                          src={userData?.pic || "../assets/images/profile/user-1.jpg"}
                          // src={ "../assets/images/profile/user-1.jpg"}
                          className="rounded-circle"
                          width="35"
                          height="35"
                          alt="User"
                        />
                      </div>
                    </div>
                  </a>
                  <div
                    className={`dropdown-menu content-dd dropdown-menu-end dropdown-menu-animate-up ${
                      profileOpen ? 'show' : ''
                    }`} 
                    data-bs-popper
                  >
                    <div className="profile-dropdown position-relative" data-simplebar>
                      <div className="py-3 px-7 pb-0">
                        <h5 className="mb-0 fs-5 fw-semibold">User Profile</h5>
                      </div>
                      <div className="d-flex align-items-center py-9 mx-7 border-bottom">
                        <img
                          src={userData?.pic || "../assets/images/profile/user-1.jpg"}
                          // src={"../assets/images/profile/user-1.jpg"}
                          className="rounded-circle"
                          width="80"
                          height="80"
                          alt="User"
                        />
                        <div className="ms-3">
                          <h5 className="mb-1 fs-3">
                            {userData ? `${userData.first_name} ${userData.last_name}` : 'Loading...'}
                          </h5>
                          <span className="mb-1 d-block">
                            {userData ? `${userData.role?.name}`: 'Loading...'}
                          </span>
                          <p className="mb-0 d-flex align-items-center gap-2">
                            <i className="ti ti-mail fs-4"></i> 
                            {userData ? userData.email : 'Loading...'}
                          </p>
                        </div>
                      </div>
                      <div className="message-body">
                        <div className="py-3 px-7">
                          <button
                            onClick={handleLogout}
                            className="btn d-flex align-items-center justify-content-center w-100 btn-outline-primary"
                            type="button"
                          >
                            <i className="ti ti-logout fs-4 me-2"></i>
                            Logout
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </nav>

        {/* Mobile Sidebar Overlay */}
        <div
          ref={darkTransparentRef}
          className="dark-transparent"
          onClick={closeMobileSidebar}
          style={{ display: mobileSidebarOpen ? 'block' : 'none' }}
        ></div>

        {/* Search Modal */}
        {searchOpen && (
          <>
            <div className="modal show" style={{ display: 'block' }}>
              <div className="modal-dialog modal-dialog-scrollable modal-lg">
                <div className="modal-content rounded-1">
                  <div className="modal-header border-bottom">
                    <input
                      type="search"
                      className="form-control fs-3"
                      placeholder="Search here"
                      autoFocus
                    />
                    <a  onClick={toggleSearch} className="lh-1">
                      <i className="ti ti-x fs-5 ms-3"></i>
                    </a>
                  </div>
                  <div className="modal-body message-body" data-simplebar>
                    <h5 className="mb-0 fs-5 p-1">Quick Page Links</h5>
                    <ul className="list mb-0 py-2">
                      <li className="p-1 mb-1 bg-hover-light-black">
                        <a >
                          <span className="fs-3 text-dark fw-normal d-block">Modern</span>
                          <span className="fs-3 text-muted d-block">/dashboards/dashboard1</span>
                        </a>
                      </li>
                      <li className="p-1 mb-1 bg-hover-light-black">
                        <a href="#">
                          <span className="fs-3 text-dark fw-normal d-block">Dashboard</span>
                          <span className="fs-3 text-muted d-block">/dashboards/dashboard2</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-backdrop fade show"></div>
          </>
        )}
      </div>
    </header>
  );
};

export default Topbar;